import { Component, OnInit } from '@angular/core';
import { AwardService } from '../../../../core/services/awards/awards.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-all-awards',
    templateUrl: './all-awards.component.html',
    styleUrls: ['./all-awards.component.scss']
})
export class AllAwardsComponent implements OnInit {
    allWinners: any;
    selectedCategory: any = 0;
    headerName: any = 'All awardees'
    allWinnersCopy: any;
    awardSelection:any;
    version:any=[];
    allVersions:any=[];
    isArchive:boolean=false;

    constructor(public awardsService: AwardService, private router: Router) { }

    ngOnInit(): void {
        if(this.router.url.includes('/archive')){
            this.isArchive = true;
        this.getAllVersion()

        }

        this.awardsService.getAllAwardsWinner().subscribe((res) => {
            this.allWinners = res.awardWinners;
            this.allWinnersCopy = res.awardWinners;
        }, err => {

        })
    }

    onSelectIndex(event) {
        this.selectedCategory = event;
        switch (event) {
            case 0:
                this.allWinners = this.allWinnersCopy;
                this.headerName = 'All awardees'
                break;
            case 1:
                this.allWinners = this.allWinnersCopy.filter((v) => v.category == "audience" || v.category == 'Audience');
                this.headerName = 'Audience'
                break;
            case 2:
                this.allWinners = this.allWinnersCopy.filter((v) => v.category == "jury");
                this.headerName = 'Jury'
                break;
        }
    }

    onChangeCategory(event: any) {
        this.awardSelection = event;
    }

    goToLink(url: string, type?:any){
        if(type === 'Jury'){
            window.open(url);
        }else{
            if (/(http(s?)):\/\//i.test(url)) {
                window.open(url, "_blank");
            } else {
                window.open(`https://${url}`);
            }
        }

    }

    onChangeVersion(event:any){
        this.awardsService.getArchivedWinnersByVersion(this.version).subscribe(data=>{
            this.allWinners = data.awardWinners;
            this.allWinnersCopy = data.awardWinners;
        },err=>{
            alert("Error while fetching data")
        })
    }

    getAllVersion() {
        this.awardsService.getAllAwardsVersion().subscribe(data => {
            this.allVersions = data.awardsVersions;
            this.version = this.allVersions.find((v) => v.isCurrent == 1)['id'];
        }, err => {

        })
    }

}